exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.e-t-p[data-v-f2d68e6e]{background:transparent\n}\n.e-t-p__header[data-v-f2d68e6e]{position:relative;min-height:.4rem;margin-bottom:.28rem\n}\n.e-t-p__title[data-v-f2d68e6e]{font-size:.43rem;color:#fff;text-align:center;letter-spacing:.08rem\n}\n.e-t-p__close[data-v-f2d68e6e]{width:.35rem;height:.35rem;position:absolute;top:0;right:0\n}\n.e-t-p__body[data-v-f2d68e6e]{border-radius:.16rem\n}", ""]);

// exports
